import axios from "axios";
import { API_BASE_URL } from "../../config/apiConfig";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((config) => {
  const user = JSON.parse(localStorage.getItem("user"));
  if (user?.token) {
    config.headers.Authorization = `Bearer ${user.token}`;
  }
  return config;
});

export const researchRoomApi = {
  /**
   * GET MY RESEARCH ROOMS (for linking to collaborations)
   * Endpoint: GET /api/research-rooms/my-rooms?role=leader
   * Response: { success, count, data: [...rooms] }
   */
  getMyRooms: async (role = null) => {
    const queryParams = role ? `?role=${role}` : "";
    return apiClient.get(`/research-rooms/my-rooms${queryParams}`);
  },
};

export default researchRoomApi;
